import { createRenderer as createFelaRenderer } from 'fela'
import friendlyPsuedo from 'fela-plugin-friendly-pseudo-class'
import placeholderPrefixer from 'fela-plugin-placeholder-prefixer'
import unit from 'fela-plugin-unit'
import webPreset from 'fela-preset-web'
// import monolithic from 'fela-monolithic'
import namedMediaQuery from 'fela-plugin-named-media-query'
import sortClassNames from 'fela-sort-classnames'
import whitelistMediaQuery from './whitelistMediaQueryPlugin'
import theme from './base-ui-theme'

const { mediaQueries } = theme
const mediaQueriesPrefixed = Object.keys(mediaQueries).reduce((agg, key) => {
	const aggregator = agg
	aggregator[key] = `@media ${mediaQueries[key]}`

	return aggregator
}, {})

const createRenderer = () => {
	const plugins = [
		...webPreset,
		friendlyPsuedo(),
		namedMediaQuery(mediaQueriesPrefixed),
		placeholderPrefixer(),
		unit('px'),
	]
	const enhancers = [sortClassNames()]

	if (process.env.NODE_ENV === 'development') {
		const validator = require('fela-plugin-validator').default
		const beautifer = require('fela-beautifier').default
		plugins.push(
			validator({
				logInvalid: true,
				deleteInvalid: true,
			})
		)
		plugins.push(whitelistMediaQuery(mediaQueriesPrefixed))
		// enable statistics if set from server config.
		if (__CLIENT__) {
			if (window && window.felaStatisticsMode) {
				const statistics = require('fela-statistics').default
				plugins.push(statistics())
			}
		}
		enhancers.push(beautifer())
	}
	// enhancers.push(monolithic({ prettySelectors: true }))

	return createFelaRenderer({
		plugins,
		enhancers,
		selectorPrefix: 'df-',
		mediaQueryOrder: [
			mediaQueries.mobile,
			mediaQueries.mobileXXs,
			mediaQueries.mobileXs,
			mediaQueries.mobileX,
			mediaQueries.mobileXl,
			mediaQueries.tablet,
			mediaQueries.tabletXS,
			mediaQueries.desktop,
			mediaQueries.desktopX,
			mediaQueries.desktopXl,
		],
		devMode: process.env.NODE_ENV !== 'production',
	})
}

export default createRenderer
